import {
  FETCH_GETTOUCH_REQUEST,
  FETCH_GETTOUCH_SUCCESS,
  FETCH_GETTOUCH_FAILURE,
  SEARCH_GETINTOUCH_REQUEST,
  SEARCH_GETINTOUCH_SUCCESS,
  SEARCH_GETINTOUCH_FAILURE
} from "./getInTouchAction";

const initialState = {
  loading: false,
  getInTouchData: [],
  searchResults:[],
  error: "",
};

const getInTouchReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GETTOUCH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_GETTOUCH_SUCCESS:
      return {
        loading: false,
        getInTouchData: [...state.getInTouchData, ...action.payload],
        error: '',
      };
    case FETCH_GETTOUCH_FAILURE:
      return {
        loading: false,
        getInTouchData: [],
        error: action.payload,
      };
      case SEARCH_GETINTOUCH_REQUEST:
        return {
          ...state,
          loading: false,
        };
      case SEARCH_GETINTOUCH_SUCCESS:
        return {
          ...state,
          loading: false,
          searchResults: action.payload,
          error: '',
        };
      case SEARCH_GETINTOUCH_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
    default:
      return state;
  }
};


export default getInTouchReducer;